<template>
  <div class="blankBox riskManage">
    <div class="searchBox">
      <table border="0" cellpadding="0" cellspacing="0" class="selectTb serchFilter" style="padding-left: 0;padding-top: 15px;">
        <tr>
          <td class="td1">
            {{ $t("loan.applyCompany") }}：
          </td>
          <td class="td2">
            <el-input
              v-model="criteria.applyCompany"
              :placeholder="$t('financingFundList.enterPlaceHolder')"
              class="theme-gray"
              style="width:250px;"
            />
          </td>
          <td class="td3">{{ $t("financingFundList.applyStatus") }}：</td>
          <td class="td4">
            <el-select
              v-model="criteria.state"
              :placeholder="$t('accountcenter.plsChoice')"
              class="theme-gray"
              style="width: 250px"
              multiple
            >
              <el-option
                v-for="(val,key) in options"
                :key="val"
                :label="$t(`zmaRiskList.${val}`)"
                :value="key"
              />
            </el-select>
          </td>
        </tr>
        <tr>
          <td class="td1">
            {{ $t('financing.startTime')+'：' }}
          </td>
          <td class="td2">
            <el-date-picker v-model="criteria.startTime" :placeholder="$t('loan.selectTime')" style="width: 250px" format="yyyy-MM-dd" class="theme-gray" type="date"/>
          </td>
          <td class="td3">
            {{ $t('financing.endTime')+'：' }}
          </td>
          <td class="td4">
            <el-date-picker v-model="criteria.endTime" :placeholder="$t('loan.selectTime')" style="width: 250px" format="yyyy-MM-dd" class="theme-gray"/>
          </td>
        </tr>
        <tr>
          <td class="td1">
            {{ $t("flowLists.flowNumber") }}：
          </td>
          <td class="td2">
            <el-input
              v-model="criteria.flowNumber"
              :placeholder="$t('financingFundList.enterPlaceHolder')"
              class="theme-gray"
              style="width:250px;"
            />
          </td>
          <td class="td3"/>
          <td class="td4"/>
        </tr>
      </table>
      <div class="text-center">
        <div class="centerBtn btn-blue" style="margin-bottom: 30px;margin-top: 10px" @click="getList(1)">
          {{ $t('btns.query') }}
        </div>
      </div>
    </div>
    <!-- 表格 -->

    <el-table :data="dataList" class="dataTable">
      <el-table-column :label="$t('contractManage.orderNum')" width="50" align="left">
        <template slot-scope="scope">
          <span>{{ ((page.pageNo-1) * page.rows) + scope.$index+1 }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('common.applyDate')" width="125">
        <template slot-scope="scope">{{ scope.row.applyTime | dateConvert }}</template>
      </el-table-column>
      <!--      申请日期-->

      <el-table-column :label="$t('flowLists.flowNumber')" prop="flowNumber" width="160"/>
      <el-table-column :label="$t('loan.applyCompany')" :show-overflow-tooltip="true" prop="applyCompany" width="170"/>
      <el-table-column :label="$t('financingFundList.applyMoneyTr')" width="150">
        <template slot-scope="scope">{{ scope.row.applyMoneyType }} {{ scope.row.applyMoney | formatNum }}</template>
      </el-table-column>
      <el-table-column :label="$t('newrisk.risk_assessment')" width="210">
        <template slot-scope="scope">
          <div v-if="scope.row.zmaRiskScore.buyerScore">{{ $t('loan.buyerCompany') }}  : {{ scope.row.zmaRiskScore.buyerScore }}</div>
          <div v-if="scope.row.zmaRiskScore.sellerScore">{{ $t('loan.salerCompany') }} : {{ scope.row.zmaRiskScore.sellerScore }}</div>
          <div v-if="scope.row.zmaRiskScore.categoryScore" >{{ $t('newrisk.coal') }}  : <span >{{ ratingLevelType(scope.row.zmaRiskScore.categoryScore) }} {{ scope.row.zmaRiskScore.categoryScore }}</span></div>
        </template>
      </el-table-column>
      <!-- <el-table-column :label="$t('financingFundDetail.customerLevel')" width="105">
        <template slot-scope="scope">
          {{scope.row.companyRatingLevel ? 'Level '+scope.row.companyRatingLevel : ''}}
        </template>
      </el-table-column>
      <el-table-column :label="$t('loan.producteRate')" width="140">
        <template slot-scope="scope">{{scope.row.productRatingLevel ? 'Level '+scope.row.productRatingLevel : ''}}</template>
      </el-table-column> -->

      <!-- 申请状态 -->
      <el-table-column :label="$t('loan.status')" width="165" align="left" fixed="right">
        <template slot-scope="scope">
          {{ $t(`zmaRiskList.${options[scope.row.applicationStatus]}`) }}
        </template>
      </el-table-column>
      <!-- 功能 -->
      <el-table-column :label="$t('contractManage.function')" align="center" fixed="right">
        <template slot-scope="scope">
          <router-link v-if="isView(scope.row.applicationStatus)" :to="`/rongzisqs?id=${scope.row.flowNumber}&menuType=1`"><span>{{ $t('btns.view') }}</span></router-link>
          <!-- 查看 -->
          <router-link v-if="isAudit(scope.row.applicationStatus)" :to="`/rongzisqs?id=${scope.row.flowNumber}&menuType=1`"><span>{{ $t('btns.audit') }}</span></router-link>
          <!-- 审核 -->
          <router-link v-if="isApply(scope.row.applicationStatus)" :to="`/rongzisqs?id=${scope.row.flowNumber}&menuType=1`"><span>{{ $t('btns.apply') }}</span></router-link>
          <!-- 申请 -->
        </template>
      </el-table-column>
      <template slot="empty">
        <div class="statusEmpty"><i/>{{ $t('financing.noData') }}</div>
      </template>
    </el-table-column></el-table>
    <el-pagination
      v-show="page.total"
      :total="page.total"
      :page-size="page.rows"
      :current-page.sync="page.pageNo"
      class="page-theme"
      background
      layout="prev, pager, next"
      style="text-align: center;padding-top:30px; padding-bottom: 30px; "
      @current-change="getList(page.pageNo)"/>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import dayjs from 'dayjs'
import Tbutton from '../../components/Tbutton'
import mixins from '@/helper/mixins.js'
export default {
  name: 'RiskManage',
  components: {
    Tbutton
  },
  mixins: [mixins],
  data() {
    return {
      criteria: {
        applyCompany: '',
        flowNumber: '',
        btnLimit: [], // 按钮权限集合
        startTime: dayjs().subtract(12, 'month').toString(),
        endTime: dayjs().toString(),
        state: []
      },
      options: {},
      // dataList: {},

      dataList: [],
      page: {
        pageNo: 1, // 当前页数
        rows: 10,
        total: 0
      }, // 分页数据
      // 当前页码
      pg_st: 1
    }
  },
  computed: {
    ...mapState(['userProfile']),
    loanName() {
      return this.userProfile.loanName // 登录用户名
    }
  },
  mounted() {
    const isSuper = this.isSuper()
    if (isSuper) { // 如果是超级管理员 所有的权限都会有
      this.btnLimit = [1, 4, 5, 6]
    } else {
      this.getMenuLimit(1).then(data => {
        this.btnLimit = data
      })
    }
    document.title = this.$t('head.applyWind')
    this.$nextTick(function() {
      this.getdiscList()
      this.getList(1)
    })
  },
  methods: {
    ratingLevelType(ratingLevel) {
      if (ratingLevel < 40) {
        return 'D'
      } else if (ratingLevel >= 40 && ratingLevel < 60) {
        return 'C'
      } else if (ratingLevel >= 60 && ratingLevel < 80) {
        return 'B'
      } else if (ratingLevel >= 80 && ratingLevel <= 100) {
        return 'A'
      }
    },
    isView(status) {
      status = parseInt(status)
      if ((this.btnLimit.indexOf(1) < 0) || (status == 4 && (this.btnLimit.indexOf(4) > -1)) || (status == 5 && (this.btnLimit.indexOf(5) > -1)) || (status == 6 && (this.btnLimit.indexOf(6) > -1))) {
        return false
      } else {
        return true
      }
    }, // 是否展示查看
    isAudit(status) {
      status = parseInt(status)
      if ((status == 5 && (this.btnLimit.indexOf(5) > -1)) || (status == 6 && (this.btnLimit.indexOf(6) > -1))) {
        return true
      } else {
        return false
      }
    }, // 是否展示审核
    isApply(status) {
      status = parseInt(status)
      if (status == 4 && (this.btnLimit.indexOf(4) > -1)) {
        return true
      } else {
        return false
      }
    }, // 是否展示申请
    getList(pageNo) {
      this.page.pageNo = pageNo
      const params = {
        applyCompany: this.criteria.applyCompany,
        rows: 10,
        page: pageNo,
        flowNumber: this.criteria.flowNumber,
        statusList: this.criteria.state.join(',')
      }
      if (this.criteria.startTime) {
        params.startTime = new Date(new Date(this.criteria.startTime).setHours(0, 0, 0, 0)).toString()
      }
      if (this.criteria.endTime) {
        params.endTime = new Date(new Date(this.criteria.endTime).setHours(23, 59, 59, 59)).toString()
      }
      this.axios.post('/api/zma/risk/selectPageForRisk', params).then(res => {
        if (res.status) {
          this.page.total = res.data.count
          this.dataList = res.data.data
        } else {
          this.$message.error(this.$t(`error.${res.errorCode}`))
        }
      })
    },
    /**
     * 取字典表
     */
    getdiscList() {
      this.axios.get('/static/sysDict/sysDictValue.json')
        .then(res => {
          if (res.zmaRiskList.en) {
            this.options = res.zmaRiskList.en
          }
        })
        .catch(err => {
          console.log(err)
          this.$message.error(this.$t(`frontPage.${err.errorCode}`))
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.riskManage {
  font-size: 14px;

  .searchBox {
    .selectTb{
      table-layout:fixed;
      td{
        font-size: 14px;
        color: #333333;
        height: 40px;
        line-height: 40px;
        padding:10px 30px;
        &.td2{
          padding-right: 10px;
          padding-left: 0;
        }
        &.td4{
          padding-left: 0;
        }
      }
    }
  }

}
</style>

